import {useEffect} from "react";
import {DatePickerFilter, DateRangePickerFilter, InputFilter, SearchFilter, SelectFilter} from "./elements";
import {Form, Space, Button} from "antd";
import style from './style.module.scss'
import cn from "classnames/bind";
import dayjs from "dayjs";

export const Filter = ({useFilters, onChange, initialValues, wrapper}) => {
    const [form] = Form.useForm();

    useEffect(()=>{
        form.setFieldsValue(defaultValueParse(initialValues))
    }, [])

    const onResetFilter = () =>{

    }

    const onFinish = (values) =>{
        if (onChange){
            onChange(transformDataResponse(values))
        }
    }

    const transformDataResponse = (values) =>{
        useFilters.forEach((item)=>{
            const name = item.name ?? getDefaultFilterName(item.type)
            switch (item.type){
                case 'date':
                case 'dateRange':
                    const format = item.hasOwnProperty('format') ? item.format : 'YYYY-MM-DD'

                    if (item.type === 'dateRange'){
                        values = {
                            ...values,
                            [name]: values[name]
                                ? {
                                    start: values[name][0].format(format),
                                    end: values[name][1].format(format),
                                }
                                : null
                        }
                    }else {
                        values = {
                            ...values,
                            [name]: values[name] ? values[name].format(format) : null
                        }
                    }
                    break;
                case 'search':
                    values = {
                        ...values,
                        [name]: values[name] ? values[name] : null
                    }
                    break;
            }
        })

        return values
    }

    const defaultValueParse = (values) =>{
        if (values){
            useFilters.forEach((item)=>{
                const name = item.name ?? getDefaultFilterName(item.type)
                switch (item.type){
                    case 'date':
                        const date = values.hasOwnProperty(name) ? values[name] : null

                        if (date){
                            values = {
                                ...values,
                                [name]: dayjs(date)
                            }
                        }
                        break
                    case 'dateRange':
                        const dateRange = values.hasOwnProperty(name) ? values[name] : null

                        if (dateRange){
                            values = {
                                ...values,
                                [name]: [dayjs(dateRange.start), dayjs(dateRange.end)]
                            }
                        }
                        break
                }
            })

            return values
        }
        return {}
    }

    const RenderFilters = () =>{
        return (
            <Wrapper
                level={1}
            >
                {useFilters.map((filter, filterIndex)=>{
                    if (Array.isArray(filter)){
                        return (
                            <Wrapper
                                level={2}
                                key={filterIndex}
                            >
                                {filter.map((item, key)=>getFilter(item, `${filterIndex}_${key}`))}
                            </Wrapper>
                        )
                    }

                    return getFilter(filter, filterIndex)
                })}
            </Wrapper>
        )
    }

    const Wrapper = ({children, level}) =>{
        if (wrapper && typeof wrapper === 'function'){
            return wrapper(children, level)
        }else {
           return(
               <Space
                   size={12}
                   wrap
               >
                   {children}
               </Space>
           )
        }
    }

    return (
        <Form
            form={form}
            name="search"
            autoComplete="off"
            layout={'vertical'}
            onFinish={onFinish}
        >
            <RenderFilters
                style={{
                    marginBottom: 16
                }}
            />

            <Form.Item
                hidden
                noStyle
            >
                <Button htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
    );
}

const iconInout = (icon) =>{
    switch (icon){
        default:
            return {
                prefix: null
            }
    }
}

const getFilter = (filter, key) =>{
    const name = filter.name ?? getDefaultFilterName(filter)
    const keyNode = `${name}_${key}`

    switch (filter.type){
        case 'search':
            return <SearchFilter {...filter} name={name} key={keyNode}/>
        case 'date':
            return <DatePickerFilter {...filter} name={name} key={keyNode}/>
        case 'dateRange':
            return <DateRangePickerFilter {...filter} name={name} key={keyNode}/>
        case 'select':
            return <SelectFilter {...filter} name={name} key={keyNode}/>
        case 'input':
            return <InputFilter {...filter} name={name} {...iconInout(filter.icon)} key={keyNode}/>
        case 'space':
            return <SpaceBetween {...filter} key={keyNode}/>
        default:
            return null
    }
}

const getDefaultFilterName = (filterType) =>{
    return filterType
}

const SpaceBetween = ({className, ...props}) =>{
    return(
        <>
            <div
                className={cn(style.space_between_wrapper, className)}
                {...props}
            />
        </>
    )
}